let store = null;
export const getStore = () => store;
export const setStore = (x) => (store = x);
